import {
  components, constants,
  useTranslation
} from 'cng-web-lib'

import CompanyCustomRulePermissionFormProperties from './CompanyCustomRulePermissionFormProperties'
import CompanyCustomRulePermissionApiUrls from 'src/apiUrls/CompanyCustomRulePermissionApiUrls'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import AccessLevelCompanyCustomRuleKeys from 'src/constants/locale/key/AccessLevelCompanyCustomRule'


const {
  table: {
    CngServerModeDialogFormTable,
    useFetchCustomLookup,
    useFetchCodeMaintenanceLookup,
    useDefaultNotification,
  }
} = components


function CompanyCustomRulePermissionCrudTable({
  showNotification,
  accessLevelCompanyCustomRuleId,
  isViewOnly = false
}) {
  const { translate } = useTranslation([Namespace.ACCESS_LEVEL_COMPANY_CUSTOM_RULE])
  const translatedTextsObject = makeTranslatedTextsObject()

  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup();
  const fetchCustomLookup = useFetchCustomLookup();
  const notification = useDefaultNotification(showNotification);

  let create = { url: CompanyCustomRulePermissionApiUrls.POST }
  let update = { url: CompanyCustomRulePermissionApiUrls.PUT }
  let del = { url: CompanyCustomRulePermissionApiUrls.DELETE }
  if (isViewOnly) {
    create = undefined
    update = undefined
    del = undefined
  }

  function makeTranslatedTextsObject() {
    let moduleCode = translate(
      Namespace.ACCESS_LEVEL_COMPANY_CUSTOM_RULE,
      AccessLevelCompanyCustomRuleKeys.CompanyCustomRulePermission.MODULE_CODE
    )
    let menuCode = translate(
      Namespace.ACCESS_LEVEL_COMPANY_CUSTOM_RULE,
      AccessLevelCompanyCustomRuleKeys.CompanyCustomRulePermission.MENU_CODE
    )
    let accessLevelMasterId = translate(
      Namespace.ACCESS_LEVEL_COMPANY_CUSTOM_RULE,
      AccessLevelCompanyCustomRuleKeys.CompanyCustomRulePermission.ACCESS_LEVEL_MASTER_ID
    )
    let accessLevelMasterChildList = translate(
      Namespace.ACCESS_LEVEL_COMPANY_CUSTOM_RULE,
      AccessLevelCompanyCustomRuleKeys.CompanyCustomRulePermission.ACCESS_LEVEL_MASTER_CHILD_LIST
    )

    return {
      moduleCode,
      menuCode,
      accessLevelMasterId,
      accessLevelMasterChildList
    }
  }

  const columns = [
    {
      field: 'moduleCode',
      title: translatedTextsObject.moduleCode,
      customLookup: () => {
        return fetchCodeMaintenanceLookup(
          constants.CodeMaintenanceType.MODULE,
          (error) => { notification.error(error.message) }
        )
      },
    },
    {
      field: 'menuCode',
      title: translatedTextsObject.menuCode,
      customLookup: () => {
        return fetchCodeMaintenanceLookup(
          constants.CodeMaintenanceType.MENU,
          (error) => { notification.error(error.message) }
        )
      },
    },
    {
      field: 'accessLevelMasterId',
      title: translatedTextsObject.accessLevelMasterId,
      customLookup: () => {
        return fetchCustomLookup(
          `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/account-setup/access-level-master/hdr/get`,
          { },
          'content',
          'name',
          'id',
          (error) => console.error(error)
        )
      },
    },
    {
      field: 'accessLevelMasterChildCodeList',
      title: translatedTextsObject.accessLevelMasterChildList,
    }
  ]

  return (
    <CngServerModeDialogFormTable
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      disabled={isViewOnly}
      showNotification={showNotification}
      tableColumns={columns}
      formProperties={{
        ...CompanyCustomRulePermissionFormProperties,
        formikProps: {
          ...CompanyCustomRulePermissionFormProperties.formikProps,
          initialValues: {
            ...CompanyCustomRulePermissionFormProperties.formikProps.initialValues,
            accessLevelCompanyCustomRuleId: accessLevelCompanyCustomRuleId
          }
        },
        customFieldsProps: { accessLevelCompanyCustomRuleId: accessLevelCompanyCustomRuleId }
      }}
      toClientDataFormat={(serverData) => {
        return serverData;
      }}
      toServerDataFormat={(localDatum) => {
        return localDatum;
      }}
      fetch={{
        url: CompanyCustomRulePermissionApiUrls.GET,
        body: {
          accessLevelCompanyCustomRuleId: accessLevelCompanyCustomRuleId
        }
      }}
      create={create}
      update={update}
      del={del}
      idAccessor='id'
    // tableConfigurationCode=''
    />
  )
}

export default CompanyCustomRulePermissionCrudTable
